import { MouseEvent } from 'react';
import { Box, Tooltip } from '@mui/material';
import { Icon } from '@/common/components';

type Props = {
  title: string;
};

function TableHeaderInfoTooltip({ title }: Props) {
  const stopSortToggle = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <Tooltip
      title={title}
      placement="top"
      arrow
      slotProps={{
        tooltip: {
          sx: { whiteSpace: 'pre-line' },
        },
      }}
      data-testid="table-header-info-tooltip"
    >
      <Box
        component="span"
        onClick={stopSortToggle}
        onMouseDown={stopSortToggle}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          flexShrink: 0,
          marginLeft: 'auto',
          lineHeight: 0,
        }}
      >
        <Icon name="lely-icon-information" aria-hidden />
      </Box>
    </Tooltip>
  );
}

export default TableHeaderInfoTooltip;
